import React, { useState } from 'react'
import secMan from "../../assets/img/form_partner.jpg";
import gradGirl from "../../assets/img/grad-girl.jpg";
import "../../components/Forms/Auth.scss"
import EmailSent from '../../components/EmailSent/EmailSent';
import RegistratiForm from '../../components/Forms/RegistratiForm/RegistratiForm';

const RegistratiPage = () => {
    const [userData, setUserData] = useState(null);

    const handleFetchData = (data) => {
        if(data.username) {
            setUserData(data);
        } else {
            setUserData(null);
        }
     };

    return (
    <>
    <form >
        <div className="auth-content d-flex align-items-center justify-content-center my-5">
        <div className="container my-5">
            <div className="card authCard rounded shadow">
                <div className="row" style={{minHeight: '600px'}}>
                    <div className="col-sm-12 col-md-12 col-xl-6 order-xl-1 order-1">
                        <div className="info-content d-flex align-items-center justify-content-center text-light register-page">
                            <img className="info-img" src={localStorage.getItem("idSP") > 0 ? secMan : gradGirl} alt="Security man" />
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-12 col-xl-6 order-xl-2 order-2">
                       <div className="form-content">
                         {
                         userData?.id ? 
                         <EmailSent userData={userData}/> 
                         :
                         <RegistratiForm onFetchData={handleFetchData}/>
                         }
                       </div>
                    </div>
                </div>
            </div>
       </div>
     </div>
    </form>
    </>
  )
}

export default RegistratiPage